import _ from "lodash";
import moment from "moment";
import React, { useMemo, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { Header, Segment, Menu, Grid, Card } from "semantic-ui-react";

import { PublicWrapper } from "../../../../components/PublicWrapper";
import PermitsViewForm from "../../components/ViewForm";

import "./PermitDetails.scss";
import usePermit from "../../hooks/permits/usePermit";
import usePermitType from "../../hooks/permits/usePermitType";

export const PermitView = () => {
  const location = useLocation();
  const contentRef = useRef(null);
  const { site, id } = useParams<{ site: string; id: string }>();
  const permitForm = useForm({
    shouldUnregister: false,
  });
  const apiId = `view/${id}`;
  const permitQuery = usePermit({ permitId: apiId });
  const permitsTypeId = useMemo(() => _.get(permitQuery.data, "data.attributes.permits-type-id"), [permitQuery.data]);
  const permitsDocuments = useMemo(() => _.get(permitQuery.data, "data.attributes.documents.data"), [permitQuery.data]);
  const sections = useMemo(() => _.get(permitQuery.data, "data.attributes.sections"), [permitQuery.data]);
  const permitsTypeQuery = usePermitType({ permitTypeId: permitsTypeId });
  const permitsTypeName = useMemo(() => _.get(permitsTypeQuery.data, "data.attributes.name"), [permitsTypeQuery.data]);
  const permitNumber = useMemo(() => _.get(permitQuery.data, "data.attributes.reservation-number"), [permitQuery.data]);

  return (
    <PublicWrapper homeUrl={`/${site}/public/permits`} contentRef={contentRef}>
      <Segment basic style={{ flex: "1", marginTop: 16, display: "flex", flexDirection: "column" }}>
        <Grid>
          <Grid.Column width={16} style={{ paddingTop: "0", paddingBottom: "0" }}>
            <Segment className='detailsHeader'>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <div>
                  <Header as='h3' className='appID'>
                    {permitNumber}
                  </Header>
                  <Header as='h2' style={{ margin: "4px" }}>
                    {permitsTypeName}
                  </Header>
                </div>
              </div>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={4} tablet={16} mobile={16}>
            {/* <PublicInfoCard permitId={id}/> */}
            <Segment className={"permitSegment"}>
              <Header as='h4' className='captionText'>
                DOCUMENTS
              </Header>
              <Menu fluid secondary vertical>
                {permitsDocuments?.map((document: any, index: number) => {
                  return (
                    <Menu.Item
                      className='permitsMenu'
                      style={{ paddingLeft: 6 }}
                      name={document.attributes?.title}
                      key={index}
                    >
                      <div>
                        <a
                          className='document_link'
                          href={document.attributes?.document_url ?? "#"}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {document.attributes?.title}
                        </a>
                        <p className='secondaryText' style={{ marginTop: 8 }}>
                          Issued {moment(document.attributes.created_at).format("MMM DD, YYYY")}
                        </p>
                      </div>
                    </Menu.Item>
                  );
                })}
              </Menu>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={12} mobile={16}>
            {["#application", "", "#"].includes(location.hash.toLowerCase()) && (
              <Card fluid>
                <Card.Content>
                  <Card.Header>Submission</Card.Header>
                  <FormProvider {...permitForm}>
                    <PermitsViewForm sections={sections} />
                  </FormProvider>
                </Card.Content>
              </Card>
            )}
          </Grid.Column>
        </Grid>
      </Segment>
    </PublicWrapper>
  );
};

export default PermitView;
